<template>
  <div class="video">
    <video v-if="element.style.url" controls :loop="true" muted autoplay :src="element.style.url"></video>
    <img v-else :src="picture" alt="" />
  </div>
</template>

<script>
import OnEvent from '../common/OnEvent.vue'

export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: Object,
      required: true,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      picture: require('../../../../../../../assets/images/custom-screen/video.png')
    }
  },

  mounted() {

  },
  methods: {

  }
}
</script>
<style scoped>
.video video{
  width: 100%;
  height: 100%;
}
.video img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>
